import styled from 'styled-components';

interface SiderbarOpen {
  isSidebarOpen?: boolean;
}



export const MobileBarContainer = styled.div<SiderbarOpen>`
  display: none;
  
  @media (max-width: 768px) {
    display: ${(p) => (p.isSidebarOpen ? 'none' : 'flex')};
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    
    /* Inline positioning */
    margin-right: 0.75rem;
    padding: 0.25rem;
    
    /* Reset fixed/floating styles */
    width: auto;
    height: auto;
    background: transparent;
    box-shadow: none;
    border-radius: 0.375rem;
    z-index: auto;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background: rgba(255, 255, 255, 0.1);
      transform: scale(1.05);
    }
    
    &:active {
      transform: scale(0.95);
    }

    > * {
      width: 1.75rem;
      height: 1.75rem;
      color: ${(p) => p.theme.colors.onPrimary};
    }
  }
`;

export default MobileBarContainer;
